// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import VueHtmlToPaper from 'vue-html-to-paper';

// plugins
import Auth from './plugins/Auth.js'
import Role from './plugins/RolUser.js'
import Url from './plugins/Url.js'

// autocomplete
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

// datetime
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
import { Settings, DateTimeOptions } from 'luxon'


Settings.defaultLocale = 'es'


// charts
// import HighchartsVue from 'highcharts-vue'

// Vue.use(HighchartsVue)
// confirm
import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components

// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

// vue image load
import ImageUploader from 'vue-image-upload-resize'

// icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faImages, faShip, faCoins, faCogs, faFilePdf, faCog, faAnchor, faDoorOpen, faChartLine, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { faEye,faHome, faPrint, faWrench, faUserTie, faThList, faUserPlus, faUserMinus, faArrowCircleDown, faPaperPlane, faWindowMaximize, faArrowCircleUp, faBook } from '@fortawesome/free-solid-svg-icons'
import { faRedoAlt, faEdit, faWindowClose, faUpload, faCameraRetro, faKey, faQrcode, faFileSignature, faCheckSquare } from '@fortawesome/free-solid-svg-icons'
import { faTimesCircle,faSave,faList,faFolderOpen, faSearch, faTasks, faFileDownload, faQuestionCircle, faExchangeAlt } from '@fortawesome/free-solid-svg-icons'
import { faCheck,faMinusCircle,faChevronCircleRight, faChevronCircleLeft, faSyncAlt, faFolderPlus, faArrowDown, faToggleOn, faToggleOff, faComments, faCompass, faFileExcel, faCopy, faUsers, faUser, faRoute, faTable, faArrowsAltH, faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Multiselect from 'vue-multiselect'

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

Vue.filter('numFormat',numFormat(numeral));

library.add(faPlus, faEye, faRedoAlt, faTimesCircle, faCheck, faMinusCircle, faChevronCircleRight, faChevronCircleLeft, faSave, faList,faFolderOpen, faEdit, faWindowClose, faHome, faSearch, faPrint, faWrench, faUserTie, faUpload, faCameraRetro, faImages, faShip, faCoins, faCogs, faFilePdf, faCog, faAnchor, faDoorOpen, faChartLine, faClipboardList, faThList, faUserPlus, faUserMinus, faArrowCircleDown, faSyncAlt, faPaperPlane, faTasks, faFileDownload, faFolderPlus, faKey,faQrcode, faQuestionCircle, faFileSignature, faCheck, faWindowMaximize, faCheckSquare, faArrowDown, faArrowCircleUp,faToggleOn, faToggleOff, faComments, faCompass, faFileExcel, faCopy, faBook, faUser, faUsers, faRoute, faExchangeAlt, faTable, faArrowsAltH, faPencilAlt)

// htmlTopaperConfig
const options={
  name:'_blank',
  specs:[
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=yes'
  ],
  styles:[
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    "./landscape.css"
  ]
}

const options2={
  name:'_blank',
  specs:[
    'fullscreen=yes',
    'titlebar=no',
    'scrollbars=yes'
  ],
  styles:[
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    "./landscape.css"
  ]
}

// usando datetime
Vue.component('datetime', Datetime);

// register globally
Vue.component('multiselect', Multiselect)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)


import modalPhotosBoat from "./components/verify/ModalPhotosBoat";
Vue.component('ModalPhotos', modalPhotosBoat);

// usando el confirm de vue


// Tell Vue to install the plugin.
Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: 'SI',
  cancelText: 'NO',
  animation: 'zoom'
});

Vue.config.productionTip = false

// datetime
Vue.use(Datetime)

Vue.use(VueHtmlToPaper, options);

Vue.use(Auth);
Vue.use(Role);
Vue.use(Url);
Vue.use(ImageUploader);

// axios.defaults.baseURL='http://localhost:8000/api/';
axios.defaults.baseURL='https://usarmada.armada.mil.bo/api_dgcp/public/index.php/api';

// axios.defaults.baseURL='https://capitanias.armada.mil.bo/api_dgcp/public/index.php/api';
// axios.defaults.baseURL='https://dgcp.armada.mil.bo/api_dgcp/public/index.php/api';

// axios.defaults.baseURL='https://186.121.203.254/api_dgcp/public/index.php/api'
// axios.defaults.baseURL='http://192.168.12.19/api_dgcp/public/index.php/api'
// axios.defaults.baseURL='https://192.168.2.7/api/'

// axios.get('https://192.168.1.8/api_dgcp/public/index.php/api/connect').then((data)=>{
//     if(data.data.estado){
//       axios.defaults.baseURL='https://192.168.1.8/api_dgcp/public/index.php/api'
//     }else{
//       axios.defaults.baseURL='https://186.121.203.254/api_dgcp/public/index.php/api'
//     }
    
// }).catch(err=>{
//   // console.log(err)
//   axios.defaults.baseURL='https://186.121.203.254/api_dgcp/public/index.php/api'
// });

// axios.defaults.headers.post['Content-Type']='application/x-www-form-urlencoded';
// axios.defaults.headers.post['Content-Type']='application/json';
// axios.defaults.headers.post['Access-Control-Allow-Origin']='*';
// axios.defaults.headers.common['Authorization'];

// console.log(axios.defaults.baseURL)
// axios.defaults.baseURL='http://192.168.0.4:8000/api/'

router.beforeEach( (to, from, next) =>{
  if(to.matched.some(record => record.meta.requiresAuth )){
    if(Vue.auth.loggedIn()){
      next();
    }else{
      next( {name: 'login'} );
    }
  }
  next()
});

// esto hay que habilitar para que se envie un campo oculto con el token
// axios.interceptors.request.use(function(config){
  
//   if(Vue.auth.getToken()){
    
//     // axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
//     config.headers.Authorization=`Bearer ${Vue.auth.getToken()}`;    
//   }else{
    
//     // axios.defaults.headers.common['Authorization']=`Bearer `;  
//   }
//   return config;
// },function(error){
//   // console.log(error)
//   return Promise.reject(err);
// })
// prototipos funcion global de vue
Vue.prototype.$dateWrite=function(dat){
  let months=['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
  let sposg=dat.indexOf("-");
  let cs= sposg>-1 ? '-':'/';
  let newfecha= dat.split(cs);
  // console.log(newfecha);
  let strdate='';
  if(cs==='-'){
    strdate=`${newfecha[2]}-${months[parseInt(newfecha[1]-1)]}-${newfecha[0]}`;
  }else{
    strdate=`${newfecha[0]}-${months[parseInt(newfecha[1]-1)]}-${newfecha[2]}`;
  }
  return strdate;
}

Vue.prototype.$dateMilitary=function(dat, hour){
  // console.log(fecha);
  // console.log(hora);
  // let aux_date= new Date();
  // let aux_month=aux_date.getMonth() >= 10 ? aux_date.getMonth()+1:`0${aux_date.getMonth()+1}`; 
  // // console.log(`${aux_date.getDate()}/${aux_month}/${aux_date.getFullYear()}`);
  // let dat = fecha == 0 || fecha == null ? `${aux_date.getFullYear()}-${aux_month}-${aux_date.getDate()}`:dat;
  // let hour= hora == 0 || hora == null ? '00:00':hour;
  let months=['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
  // console.log(dat);
  let sposg=dat.indexOf("-");
  let cs= sposg>-1 ? '-':'/';
  let newfecha= dat.split(cs);

  let bposp=hour.indexOf(":");
  let upos = bposp>-1 ? true:false;
  let nh;
  if(upos){
    nh = hour.split(':');
    nh=nh[0]+nh[1];
  }else{
    nh=hour;
  }
  
  // console.log(newfecha);
  let strdate='';
  if(cs==='-'){
    strdate=`${newfecha[2]}${nh}-${months[parseInt(newfecha[1]-1)]}-${newfecha[0]}`;
  }else{
    strdate=`${newfecha[0]}${nh}-${months[parseInt(newfecha[1]-1)]}-${newfecha[2]}`;
  }
  return strdate;
}

Vue.prototype.$dateConverse=function(dat){
  let partesFecha = dat.split("/");
  let anio = parseInt(partesFecha[2]);
  let mes = parseInt(partesFecha[1]) - 1; // Restar 1 al mes porque los meses en JavaScript van de 0 a 11
  let dia = parseInt(partesFecha[0]);
  let newFecha=`${anio}-${mes}-${dia}`;
  // let newFecha=new Date(anio, mes, dia);
  // let aux_fecha=newFecha.split('T');
  // return aux_fecha[0];
  return newFecha;
}

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js